// 文章类型
export const CONTENT_TYPE = {
  richText: 1,
  markdown: 2,
  componentTemplate: 3,
};

// 文章模板类型
export const COMPONENT_TEMPLATE = {
  coverResource: 'cover_resource',
  richText: 'rich_text',
  markdown: 'markdown',
  keywords: 'keywords',
  webview: 'webview',
};

export default {
  CONTENT_TYPE,
  COMPONENT_TEMPLATE,
};
